/* eslint-disable no-mixed-operators */
import React from "react";
import ReactDOM from "react-dom";
import { withStyles } from "@material-ui/core/styles";
import { serializeError } from "serialize-error";
import PersonIcon from '@material-ui/icons/Person';
import CallEndIcon from '@material-ui/icons/CallEnd';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import windowExpandIcon from "../../assets/chatExpand.svg";
import ParticipantMicOffIcon from "../../assets/participantMicOff.svg";
import ParticipantVideoOffIcon from "../../assets/participantVideoOff.svg";
import windowReduceIcon from "../../assets/chatReduce.svg";
import StepButton from '@material-ui/core/StepButton';
import SendIcon from '@material-ui/icons/Send';
import SettingsIcon from '@material-ui/icons/Settings';
import Button from '@material-ui/core/Button';
import Video, { LocalDataTrack, createLocalVideoTrack, createLocalAudioTrack } from "twilio-video";
import DeviceDetector from "device-detector-js";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TwilioComponentStyle from "../../styles/twilioComponentStyle";

const dataTrack = new LocalDataTrack();
const localMedia = React.createRef();
const remoteMedia = React.createRef();
const chatWindow = React.createRef();
const chatInput = React.createRef();

const dataTrackPublished = {};

dataTrackPublished.promise = new Promise((resolve, reject) => {
    dataTrackPublished.resolve = resolve;
    dataTrackPublished.reject = reject;
});

const VisitTypeEnum = {
    AUDIO: {
        STR: "1",
        INT: 1
    },
    VIDEO: {
        STR: "0",
        INT: 0
    }
};

const VisitSourceEnum = {
    NS: 1,
    Patient: 2,
    Prescriber: 3,
};

class TwilioComponent extends React.Component {
    constructor(props) {
        super(props);
        let { selectedCardData = {} } = props;
        let { DoctorId, VisitType, FirstName = "", LastName = "" } = selectedCardData;
        this.state = {
            isSelfViewOpen: true,
            identity: DoctorId,
            participantName: FirstName + " " + LastName,
            isParticipantOnline: false,
            activeRoom: null,
            callStatus: "initial",
            hasJoinedRoom: false,
            videoMute: (VisitType === VisitTypeEnum.AUDIO.INT || VisitType === VisitTypeEnum.AUDIO.STR) ? true : false,
            micMute: false,
            chatDisable: true,
            settingDisable: true,
            userVideoOpened: false,
            userVideoMute: false,
            endCall: false,
            chatHistory: [],
            messageText: "",
            expandWindow: false,
            audioInputDevices: [],
            audioOutputDevies: [],
            videoInputDevices: [],
            selectedAudioInputDevices: "",
            selectedAudioOutputDevies: "",
            selectedVideoInputDevices: "",
            defaultAudioInputDevice: "",
            defaultVideoInputDevice: "",
            participantVideoEnable: (VisitType === VisitTypeEnum.AUDIO.INT || VisitType === VisitTypeEnum.AUDIO.STR) ? false : true,
            participantAudioEnable: true
        }
    }
    componentDidMount() {
        this.joinRoom();
    }

    getDevices = (mediaDevices, localParticipant) => {
        mediaDevices.enumerateDevices && mediaDevices.enumerateDevices().then((mediaDevices) => this.gotDevices(mediaDevices, localParticipant));
    }

    gotDevices = (mediaDevices, localParticipant) => {
        let audioInputDevices = [], audioOutputDevies = [], videoInputDevices = [], selectedAudioInputDevices = "", selectedAudioOutputDevies = "", selectedVideoInputDevices = "";
        let defaultVideoInputDevice;
        if (localParticipant) {
            defaultVideoInputDevice = localParticipant.mediaStreamTrack.label
        } else {
            this.state.activeRoom.localParticipant.videoTracks.forEach(_ => {
                defaultVideoInputDevice = _.track.mediaStreamTrack.label
            });
        }
        mediaDevices.forEach(mediaDevice => {
            if (mediaDevice.kind === 'audioinput') {
                if (mediaDevice.deviceId === "default") {
                    selectedAudioInputDevices = mediaDevice.deviceId;
                }
                audioInputDevices.push({ value: mediaDevice.deviceId, label: mediaDevice.label });
            } else if (mediaDevice.kind === 'videoinput' || mediaDevice.kind === 'videooutput') {
                if (this.state.activeRoom && this.state.activeRoom.localParticipant && this.state.activeRoom.localParticipant.videoTracks && this.state.activeRoom.localParticipant.videoTracks.forEach) {
                    if (defaultVideoInputDevice === mediaDevice.label) {
                        selectedVideoInputDevices = mediaDevice.deviceId;
                    }
                } else if (mediaDevice.deviceId && !selectedVideoInputDevices) {
                    selectedVideoInputDevices = mediaDevice.deviceId;
                }
                videoInputDevices.push({ value: mediaDevice.deviceId, label: mediaDevice.label });
            } else if (mediaDevice.kind === 'audiooutput') {
                if (mediaDevice.deviceId === "default") {
                    selectedAudioOutputDevies = mediaDevice.deviceId;
                }
                audioOutputDevies.push({ value: mediaDevice.deviceId, label: mediaDevice.label });
            }
        });
        this.setState({ audioInputDevices, audioOutputDevies, videoInputDevices, selectedAudioInputDevices, selectedVideoInputDevices, selectedAudioOutputDevies });
    }

    componentDidUpdate(prevProps, prevState) {
        // after room is joined select the default video device from the videoInputDevices list
        if ((!prevState.defaultVideoInputDevice && this.state.defaultVideoInputDevice) || (prevState.defaultVideoInputDevice !== this.state.defaultVideoInputDevice)) {
            let selectedVideoInputDevices;
            for (let i = 0; i < this.state.videoInputDevices.length; i++) {
                if (this.state.videoInputDevices[i].label === this.state.defaultVideoInputDevice) {
                    selectedVideoInputDevices = this.state.videoInputDevices[i].value;
                    break;
                }
            }
            this.setState({ selectedVideoInputDevices });
        }
        if ((!prevState.defaultAudioInputDevice && this.state.defaultAudioInputDevice) || (prevState.defaultAudioInputDevice !== this.state.defaultAudioInputDevice)) {
            let selectedAudioInputDevices;
            for (let i = 0; i < this.state.audioInputDevices.length; i++) {
                if (this.state.audioInputDevices[i].label === this.state.defaultAudioInputDevice) {
                    selectedAudioInputDevices = this.state.audioInputDevices[i].value;
                    break;
                }
            }
            this.setState({ selectedAudioInputDevices });
        }
        if (this.state.videoInputDevices.length !== prevState.videoInputDevices.length) {
            let selectedVideoInputDevices;
            for (let i = 0; i < this.state.videoInputDevices.length; i++) {
                if (this.state.videoInputDevices[i].deviceId === this.state.selectedVideoInputDevices) {
                    selectedVideoInputDevices = this.state.selectedVideoInputDevices;
                    break;
                }
            }
            if (!selectedVideoInputDevices && this.state.videoInputDevices.length && this.state.videoInputDevices[0].deviceId) {
                this.handleVideoInputDeviceChange({ target: { value: this.state.videoInputDevices[0].deviceId } })
            }
        }
        if (!prevProps.callDetailSent && this.props.callDetailSent) {
            let { selectedCardData, callStarted, LogError } = this.props;
            let { OrderId, VisitType } = selectedCardData;
            let connectOptions = {
                name: OrderId,
                audio: true,
                video: (VisitType === 1 || VisitType === "1") ? false : true,
            };
            const token = callStarted;
            Video.connect(token, connectOptions).then(this.roomJoined, error => {
                LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: error.message });
            });
        }
    }

    UNSAFE_componentWillUnmount() {
        this.dropCall();
    }

    dropCall = () => {
        let { activeRoom } = this.state;
        let { endVisit = () => {}, callDetailSent } = this.props;
        if (activeRoom && activeRoom.localParticipant.state === 'connected') {
            endVisit(callDetailSent);
            activeRoom && activeRoom.disconnect && activeRoom.disconnect();
            this.setState({ activeRoom: null })
        }
    }

    joinRoom = async () => {
        // let { selectedCardData, selectedPrescriberInfo = {}, callStarted } = this.props, browser = "", os = "", device = "";
        // let { FirstName = "", LastName = "" } = selectedPrescriberInfo;
        // let { OrderId, UserId, VisitType } = selectedCardData;
        // let connectOptions = {
        //     name: OrderId,
        //     audio: true,
        //     video: (VisitType === 1 || VisitType === "1") ? false : true,
        // };
        // const token = callStarted;


        // Video.connect(token, connectOptions).then(this.roomJoined, error => {
        //     alert("Could not connect to Twilio: " + error.message);
        // });
        const {
            CallDetails: startVisit = async () => {},
            getNotesTabInfo = async () => {},
            selectedCardData: { UserId, DoctorId, VisitType, OrderId },
        } = this.props;

        const callDetailsData = {
            orderId: OrderId,
            doctorId: DoctorId,
            patientId: UserId,
            roomId: OrderId,
            roomName: OrderId,
            callType: VisitType,
            startDate: 0,
            source: VisitSourceEnum.Prescriber,
        };

        if (navigator) {
            let userAgent = navigator.userAgent;
            const deviceDetector = new DeviceDetector();
            const device = deviceDetector.parse(userAgent);
            const { client = {}, os = {}, device: deviceInfo = {} } = device || {};
            const { name: browserName, version: browserVersion } = client || {};
            const { name: osName, version: osVersion } = os || {};
            const { brand: deviceBrand, type: deviceType } = deviceInfo || {};
            callDetailsData.browser = `${browserName} ${browserVersion}`;
            callDetailsData.os = `${osName} ${osVersion}`;
            callDetailsData.deviceName = `${deviceBrand} ${deviceType}`;
        }

        try {
            await startVisit(callDetailsData);

            // reload the notes
            getNotesTabInfo();
        } catch(e) {

        }
    }

    roomJoined = (room) => {
        let defaultVideoInputDevice, defaultAudioInputDevice;

        if (room && room.localParticipant) {
            if (room.localParticipant.audioTracks) {
                room.localParticipant.audioTracks.forEach(_ => {
                    defaultAudioInputDevice = _.track.mediaStreamTrack.label
                })
            }
            if (room.localParticipant.videoTracks) {
                room.localParticipant.videoTracks.forEach(_ => {
                    defaultVideoInputDevice = _.track.mediaStreamTrack.label
                })
            }
        }
        // Called when a participant joins a room
        this.setState({
            activeRoom: room,
            callStatus: "inProgress",
            hasJoinedRoom: true, // Removes ‘Join Room’ button and shows ‘Leave Room’
            defaultAudioInputDevice,
            defaultVideoInputDevice
        });
        if (navigator && navigator.mediaDevices) {
            this.getDevices(navigator.mediaDevices);
            navigator.mediaDevices.ondevicechange = (event) => {
                this.getDevices(navigator.mediaDevices)
            }
        }

        var previewContainer = localMedia && localMedia.current;
        if (previewContainer && previewContainer.querySelector && !previewContainer.querySelector("video")) {
            this.attachParticipantTracks(room.localParticipant, previewContainer, true);
            room.localParticipant.publishTrack(dataTrack).catch((e) => {
                dataTrackPublished.resolve();
                let { LogError } = this.props;
                e = serializeError && serializeError(e);
                LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: JSON.stringify(e) });
                return;
            });
        }

        room.localParticipant.on('trackPublished', publication => {
            if (publication.track === dataTrack) {
                dataTrackPublished.resolve();
            }
        });

        room.localParticipant.on('trackPublicationFailed', (error, track) => {
            if (track === dataTrack) {
                dataTrackPublished.reject(error);
            }
        });

        // // Attach the events of the room and room's participants. if participants are already available
        room.participants.forEach(this.participantConnected);
        room.on("participantConnected", this.participantConnected);

        room.on("participantDisconnected", this.participantDisconnected);
        room.on("disconnected", this.roomDisconnected);

    }

    sendMessage = (message) => {
        this.setState({ chatHistory: [{ message, type: 1 }, ...this.state.chatHistory], messageText: "" })
        dataTrackPublished.promise.then(() => { dataTrack.send(message); this.scrollChatToBottom(); });
    }

    // Participant joining room
    // Here participant.tracks.size is the number of track that present of the particpant joined at the time of connection.
    // Different types of track present are "data", "audio" and "video"
    participantConnected = participant => {
        var previewContainer = remoteMedia && remoteMedia.current;
        participant.tracks.forEach(publication => {
            if (publication.isSubscribed) {
                this.attachTrack(publication.track, previewContainer, false);
            }
            publication.on('subscribed', this.handleTrackDisabled);
            publication.on('unsubscribed', this.handleTrackDisabled);
        });
        participant.on('trackSubscribed', track => {
            if (track.kind === 'data') {
                track.on('message', message => {
                    if (this.state.chatDisable) {
                        this.scrollChatToBottom();
                        this.focusChatInput();
                    }
                    this.setState({ chatHistory: [{ message, type: 2 }, ...this.state.chatHistory], chatDisable: false, settingDisable: true });
                });
            }
            this.attachTrack(track, previewContainer, false);
        });
        if (participant.tracks.size <= 1) {
            this.setState({ participantVideoEnable: false, participantAudioEnable: false, isParticipantOnline: true })
        } else if (participant.tracks.size === 2) {
            let participantTracks = Array.from(participant.tracks.values());
            let trackType = [];
            participantTracks.forEach(track => {
                if (track.kind !== "data") {
                    trackType.push(track.kind);
                }
            })
            if (trackType.length === 2) {
                this.setState({ isParticipantOnline: true, participantAudioEnable: true, participantVideoEnable: true })
            } else {
                if (trackType[0] === "audio") {
                    this.setState({ isParticipantOnline: true, participantAudioEnable: true, participantVideoEnable: false })
                } else {
                    this.setState({ isParticipantOnline: true, participantAudioEnable: false, participantVideoEnable: true })
                }
            }
        } else {
            this.setState({ isParticipantOnline: true, participantAudioEnable: true, participantVideoEnable: true })
        }
        participant.on("trackUnsubscribed", this.trackUnsubscribed);
    };

    handleTrackDisabled = (track) => {
        track.on('enabled', () => {
            /* Hide the avatar image and show the associated <video> element. */
        });
        track.on('disabled', () => {
            /* Hide the avatar image and show the associated <video> element. */
        });
    }

    setVideoStyle = (video = {}, isParticipant) => {
        if (!isParticipant) {
            video.style.transform = 'scale(-1, 1)';
        }
        video.style.height = '100%';
        video.style.width = '100%';
        video.style.minWidth = '100%';
        video.style.maxWidth = '100%';
        video.style.maxHeight = '100%';
        video.style.minHeight = '100%';
        video.style.objectFit = 'cover';
        video.style.borderRadius = '15px !important';
    }

    attachTrack = (track, container) => {
        let { LogError } = this.props;
        if (track.kind && track.kind !== "data") {
            this.state.userVideoMute && this.setState({ userVideoMute: false })
            let video = track.attach() || {};
            if (track.kind === "video") {
                this.setVideoStyle(video, "participantVideo");
                this.setState({ participantVideoEnable: true });
            }
            if (track.kind === "audio") {
                if (video.setSinkId && this.state.selectedAudioOutputDevies) {
                    video.setSinkId(this.state.selectedAudioOutputDevies).then(_ => {
                        container && container.append && container.append(video);
                    }).catch(_ => {
                        _ = serializeError && serializeError(_);
                        LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: JSON.stringify(_) })
                    });
                }
                this.setState({ participantAudioEnable: true });
            } else {
                container && container.append && container.append(video);
            }
        }
    }



    // Attach the Participant's Tracks to the DOM.
    attachParticipantTracks = (participant = {}, container, local) => {
        var tracks = Array.from(participant.tracks.values());
        this.attachTracks(tracks, container, local, participant);
    }

    // Attach the Tracks to the DOM.
    attachTracks = (tracks, container, local, participant) => {
        tracks.forEach(track => {
            if (track.kind && track.kind !== "data") {
                let video = track.track && track.track.attach && track.track.attach();
                if (video && track.kind === "video") {
                    if (local) {
                        this.setVideoStyle(video);
                    }
                }
                video && container && container.append && container.append(video);
                this.setState({ userVideoOpened: true })
            }
        });
    }

    // Participant leaving room
    participantDisconnected = participant => {
        this.setState({ isParticipantOnline: false });
        this.detachParticipantTracks(participant, false);
    };

    // Detach All Participant's Tracks to the DOM.
    detachParticipantTracks = (participant, local) => {
        var tracks = Array.from(participant.tracks.values());
        this.detachTracks(tracks, local);
    }


    // Detach all participant’s track when they leave a room.
    trackUnsubscribed = (track, participant) => {
        if (track.kind === "video") {
            this.setState({ userVideoMute: true, participantVideoEnable: false })
        } else if (track.kind === "audio") {
            this.setState({ participantAudioEnable: false })
        }
        if (track.kind && track.kind !== "data") {
            this.detachTracks([track]);
        }
    };

    // Detach the Participant's Tracks to the DOM.
    detachTracks = (tracks, local) => {
        tracks.forEach(publication => {
            if (publication.detach) {
                const attachedElements = publication.detach();
                attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
            } else if (publication.track && publication.track.stop && publication.unpublish) {
                publication.track.stop();
                publication.unpublish();
                const attachedElements = publication.track.detach && publication.track.detach();
                attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
            }
        });
    }

    roomDisconnected = (room, participant) => {
        let { SetStartVisit } = this.props;
        this.detachParticipantTracks(room.localParticipant, true);
        room.participants.forEach(this.detachParticipantTracks, false);
        this.setState({
            activeRoom: null,
            hasJoinedRoom: false,
            endCall: false
        });
        SetStartVisit && SetStartVisit(false)
    };

    toggleSelfView = () => {
        this.setState({ isSelfViewOpen: !this.state.isSelfViewOpen })
    }

    toggleExpandWindow = () => {
        this.setState({ expandWindow: !this.state.expandWindow })
    }

    toggleVideo = () => {
        let { videoMute, activeRoom } = this.state;
        if (videoMute) {
            const localParticipant = activeRoom.localParticipant;
            const tracks = Array.from(localParticipant.videoTracks.values());
            if (tracks.length === 0) {
                let deviceId = this.state.selectedVideoInputDevices ? { deviceId: { exact: this.state.selectedVideoInputDevices } } : {};
                createLocalVideoTrack({
                    ...deviceId
                }).then((localVideoTrack) => {
                    localParticipant.publishTrack(localVideoTrack);
                    const previewContainer = localMedia.current;
                    let video = localVideoTrack.attach && localVideoTrack.attach();
                    if (video) {
                        this.setVideoStyle(video);
                    }
                    previewContainer && previewContainer.append && previewContainer.append(video);
                    if (localVideoTrack.mediaStreamTrack && localVideoTrack.mediaStreamTrack.label) {
                        this.setState({ defaultVideoInputDevice: localVideoTrack.mediaStreamTrack.label })
                    }
                    if (navigator && navigator.mediaDevices) {
                        this.getDevices(navigator.mediaDevices, localVideoTrack);
                    }
                    this.setState({ videoMute: false })
                }).catch(err => {
                    let { LogError } = this.props;
                    err = serializeError && serializeError(err);
                    LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: JSON.stringify(err) });
                });
            }
        } else {
            activeRoom && activeRoom.localParticipant && activeRoom.localParticipant.videoTracks && activeRoom.localParticipant.videoTracks.forEach(publication => {
                if (publication.track && publication.track.stop && publication.unpublish) {
                    publication.track.stop();
                    publication.unpublish();
                    const attachedElements = publication.track.detach && publication.track.detach();
                    attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
                    this.setState({ videoMute: true })
                }
            });
        }
    }

    toggleMic = () => {
        let { micMute, activeRoom } = this.state;
        if (micMute) {
            const localParticipant = activeRoom.localParticipant;
            const tracks = Array.from(localParticipant.audioTracks.values());
            if (tracks.length === 0) {
                let deviceId = this.state.selectedAudioInputDevices ? { deviceId: { exact: this.state.selectedAudioInputDevices } } : {};
                createLocalAudioTrack({
                    ...deviceId
                }).then((localAudioTrack) => {
                    localParticipant.publishTrack(localAudioTrack);
                    const previewContainer = localMedia.current;
                    let audio = localAudioTrack.attach && localAudioTrack.attach();
                    previewContainer && previewContainer.append && previewContainer.append(audio);
                    if (localAudioTrack.mediaStreamTrack && localAudioTrack.mediaStreamTrack.label) {
                        this.setState({ defaultAudioInputDevice: localAudioTrack.mediaStreamTrack.label })
                    }
                    if (navigator && navigator.mediaDevices) {
                        this.getDevices(navigator.mediaDevices);
                    }
                    this.setState({ micMute: false })
                }).catch(err => {
                    let { LogError } = this.props;
                    err = serializeError && serializeError(err);
                    LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: JSON.stringify(err) });
                });
            }
        } else {
            activeRoom && activeRoom.localParticipant && activeRoom.localParticipant.audioTracks && activeRoom.localParticipant.audioTracks.forEach(publication => {
                if (publication.track && publication.track.stop && publication.unpublish) {
                    publication.track.stop();
                    publication.unpublish();
                    const attachedElements = publication.track.detach && publication.track.detach();
                    attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
                    this.setState({ micMute: true })
                }
            });
        }
    }

    endCall = () => {
        this.setState({ endCall: true });
    }

    scrollChatToBottom = () => {
        if (chatWindow && chatWindow.current) {
            const chatWindowContainer = ReactDOM.findDOMNode(chatWindow.current);
            chatWindowContainer.scrollTop = chatWindowContainer.scrollHeight;
        }
    }

    focusChatInput = () => {
        if (chatInput && chatInput.current) {
            chatInput.current.focus && chatInput.current.focus();
        }
    }

    toggleChat = () => {
        if (this.state.chatDisable) {
            this.scrollChatToBottom();
            this.focusChatInput();
        }
        this.setState({ chatDisable: !this.state.chatDisable, settingDisable: true })
    }

    toggleSetting = () => {
        this.setState({ settingDisable: !this.state.settingDisable, chatDisable: true });
    }

    handleMessage = (e) => {
        this.setState({ messageText: e.target.value })
    }
    onMessageKeyPress = (e) => {
        if (e.charCode === 13 && !e.shiftKey) {
            e.preventDefault();
            this.state.messageText.trim() && this.sendMessage(this.state.messageText);
            this.scrollChatToBottom();
        }
    }

    getSelectInput = (classes, id, data = [], value, handleChange) => {
        return (
            <FormControl variant="outlined" className={`${classes.productInput}`}>
                {
                    (id === "select-Speaker" && !data.length) ? <Select
                        labelId="customized-select-label"
                        id={id}
                        MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList, root: classes.menuPopOver }, style: { zIndex: 9999999 } }}
                        classes={{ outlined: classes.productSelectStyle }}
                        value={-1}
                        label={void 0}
                    >
                        <MenuItem
                            title={"System Default Speaker Device"}
                            classes={{ selected: classes.menuItemSelected }}
                            className={classes.menuItemRoot}
                            value={-1}>
                            System Default Speaker Device
                        </MenuItem>
                    </Select> : (id === "select-Microphone" && !data.length) ? (<Select
                        labelId="customized-select-label"
                        id={id}
                        MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList }, style: { zIndex: 9999999 } }}
                        classes={{ outlined: classes.productSelectStyle }}
                        value={-1}
                        label={void 0}
                    >
                        <MenuItem
                            title={"System Default Speaker Device"}
                            classes={{ selected: classes.menuItemSelected }}
                            className={classes.menuItemRoot}
                            value={-1}>
                            System Default Microphone Device
                        </MenuItem>
                    </Select>) : (id === "select-camera" && !data.length) ? (<Select
                        labelId="customized-select-label"
                        id={id}
                        MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList }, style: { zIndex: 9999999 } }}
                        classes={{ outlined: classes.productSelectStyle }}
                        value={-1}
                        label={void 0}
                    >
                        <MenuItem
                            title={"System Default Speaker Device"}
                            classes={{ selected: classes.menuItemSelected }}
                            className={classes.menuItemRoot}
                            value={-1}>
                            System Default Camera Device
                        </MenuItem>
                    </Select>) : (<Select
                        labelId="customized-select-label"
                        id={id}
                        MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList }, style: { zIndex: 9999999 } }}
                        classes={{ outlined: classes.productSelectStyle }}
                        value={value || data && data.length && data[0].value && data[0].value || -1}
                        onChange={handleChange}
                        label={void 0}
                    >
                        {data && data.map((_, index) => {
                            if (!_.value) {
                                return <MenuItem
                                    title={_.label}
                                    classes={{ selected: classes.menuItemSelected }}
                                    className={classes.menuItemRoot}
                                    key={index + _.label}
                                    value={-1}>
                                    {id === "select-Speaker" ? "Speaker is blocked" : id === "select-camera" ? "Camera is blocked" : "Microphone is blocked"}
                                </MenuItem>
                            }
                            return <MenuItem
                                title={_.label}
                                classes={{ selected: classes.menuItemSelected }}
                                className={classes.menuItemRoot}
                                key={index + _.label}
                                value={_.value}>
                                {_.label}
                            </MenuItem>
                        })}
                    </Select>)
                }
            </FormControl>
        )
    }

    handleVideoInputDeviceChange = (e) => {
        let { value } = e.target;
        if (this.state.videoMute) {
            this.setState({ selectedVideoInputDevices: value });
        }
        else {
            let { activeRoom } = this.state;
            const localParticipant = activeRoom.localParticipant;
            if (value !== this.state.selectedVideoInputDevices) {
                const tracks = Array.from(localParticipant.videoTracks.values());
                if (tracks && tracks.length) {
                    activeRoom && activeRoom.localParticipant && activeRoom.localParticipant.videoTracks && activeRoom.localParticipant.videoTracks.forEach(publication => {
                        if (publication.track && publication.track.stop && publication.unpublish) {
                            publication.track.stop();
                            publication.unpublish();
                            const attachedElements = publication.track.detach && publication.track.detach();
                            attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
                        }
                    });
                }
                let deviceId = value ? { deviceId: { exact: value } } : {};
                Video.createLocalVideoTrack({
                    ...deviceId
                }).then((localVideoTrack) => {
                    localParticipant.publishTrack(localVideoTrack);
                    const previewContainer = localMedia && localMedia.current;
                    let video = localVideoTrack.attach && localVideoTrack.attach();
                    if (video) {
                        this.setVideoStyle(video);
                    }
                    previewContainer && previewContainer.append && previewContainer.append(video);
                }).then(_ => {
                    this.setState({ selectedVideoInputDevices: value });
                });
            }
        }
    }

    handleAudioInputChange = (e) => {
        let { value } = e.target;
        if (this.state.micMute) {
            this.setState({ selectedAudioInputDevices: value });
        }
        else {
            let { activeRoom } = this.state;
            const localParticipant = activeRoom.localParticipant;
            if (value !== this.state.selectedAudioInputDevices) {
                const tracks = Array.from(localParticipant.audioTracks.values());
                if (tracks && tracks.length) {
                    activeRoom && activeRoom.localParticipant && activeRoom.localParticipant.audioTracks && activeRoom.localParticipant.audioTracks.forEach(publication => {
                        if (publication.track && publication.track.stop && publication.unpublish) {
                            publication.track.stop();
                            publication.unpublish();
                            const attachedElements = publication.track.detach && publication.track.detach();
                            attachedElements && attachedElements.forEach && attachedElements.forEach(element => element.remove());
                        }
                    });
                }
                let deviceId = value ? { deviceId: { exact: value } } : {};
                Video.createLocalAudioTrack({
                    ...deviceId
                }).then((localAudioTrack) => {
                    localParticipant.publishTrack(localAudioTrack);
                    const previewContainer = localMedia && localMedia.current;
                    let audio = localAudioTrack.attach && localAudioTrack.attach();
                    previewContainer && previewContainer.append && previewContainer.append(audio);
                }).then(_ => {
                    this.setState({ selectedAudioInputDevices: value });
                }).catch(_ => {
                    let { LogError } = this.props;
                    _ = serializeError && serializeError(_);
                    LogError && LogError({ "ErrorSource": "Twillio", ErrorDetails: JSON.stringify(_) });
                });
            }
        }
    }

    handleAudioOutputChange = (e) => {
        let { value } = e.target;
        if (value !== this.state.selectedAudioOutputDevies) {
            const previewContainer = remoteMedia && remoteMedia.current;
            const audioElement = previewContainer && previewContainer.getElementsByTagName && previewContainer.getElementsByTagName("audio")[0];
            if (audioElement && audioElement.setSinkId) {
                audioElement.setSinkId(value).then(_ => {
                    this.setState({ selectedAudioOutputDevies: value })
                });
            } else {
                this.setState({ selectedAudioOutputDevies: value })
            }
        }
    }

    getParticipantTrack = () => {
        let { classes } = this.props;
        if (!this.state.participantVideoEnable && !this.state.participantAudioEnable) {
            return (<div style={{ position: "absolute", width: "100%", height: "100%" }}><div className={classes.placeHolderIconWrapper}>
                <div className={classes.placeholderInsideWrapper}>
                    <PersonIcon style={{ color: "#4D4D4D" }} className={this.state.expandWindow ? classes.participantIcon : classes.placeHolderIcon} />
                    <div className={this.state.expandWindow ? classes.participantIconNameWrapper : classes.participantIconNameWrapperCollapse}>
                        <span className={this.state.expandWindow ? classes.participantIconName : classes.participantIconNameCollapse}>{this.state.participantName}</span>
                    </div>
                </div>
                <div className={classes.videoOffIconWrapper}>
                    <img src={ParticipantVideoOffIcon} className={classes.videoOffIcon} alt="" />
                </div>
            </div>
                <div className={classes.placeHolderAudioWrapper} style={{ height: "100%" }}>
                    <div className={classes.videoOffIconWrapper}>
                        <img src={ParticipantMicOffIcon} className={classes.videoOffIcon} alt="" />
                    </div>
                </div>
            </div>)
        } else if (!this.state.participantVideoEnable && this.state.participantAudioEnable) {
            return (<div className={classes.placeHolderIconWrapper}>
                <div className={classes.placeholderInsideWrapper}>
                    <PersonIcon style={{ color: "#4D4D4D" }} className={this.state.expandWindow ? classes.participantIcon : classes.placeHolderIcon} />
                    <div className={this.state.expandWindow ? classes.participantIconNameWrapper : classes.participantIconNameWrapperCollapse}>
                        <span className={this.state.expandWindow ? classes.participantIconName : classes.participantIconNameCollapse}>{this.state.participantName}</span>
                    </div>
                </div>
                <div className={classes.videoOffIconWrapper}>
                    <img src={ParticipantVideoOffIcon} className={classes.videoOffIcon} alt="" />
                </div>
            </div>)
        } else if (this.state.participantVideoEnable && !this.state.participantAudioEnable) {
            return (<div className={classes.placeHolderAudioWrapper} style={{ width: "100%" }}>
                <div className={classes.videoOffIconWrapper}>
                    <img src={ParticipantMicOffIcon} className={classes.videoOffIcon} alt="" />
                </div>
            </div>)
        }
    }

    render() {
        let { classes, loading, isVideoFocused, version = 1 } = this.props;
        let mainWidth = this.state.isSelfViewOpen ? (this.state.expandWindow ? 630 : 420) : this.state.expandWindow ? 420 : 210;
        let participantWidth = this.state.expandWindow ? 420 : 210;
        let mainHeight = this.state.expandWindow ? 360 : 180;
        let chatHeight = !this.state.chatDisable ? (this.state.expandWindow ? 630 : 360) : (this.state.expandWindow ? 360 : 180)
        let settingHeight = !this.state.settingDisable ? (this.state.expandWindow ? 630 : 360) : (this.state.expandWindow ? 360 : 180)

        const TwilioComponentClassNameMapper = new Map([
            [1, classes.twilioWrapper],
            [2, classes.twilioWrapperV2],
        ]);

        return (
            <div data-app="twilio-component-wrapper" style={{ zIndex: (loading || isVideoFocused) ? 99999 : 2 }} className={TwilioComponentClassNameMapper.get(version)}>
                <div style={{ width: mainWidth, height: mainHeight }} className={classes.twilioVideoWrapper}>
                    <div className={classes.selfView}>
                        <div className={classes.relativeContainer}>
                            <div
                                ref={localMedia}
                                className={classes.localMedia}
                                id="user-media"
                            />
                            {this.state.videoMute ?
                                <div className={classes.placeHolderIconWrapper}>
                                    <PersonIcon style={{ color: "#4D4D4D" }} className={`${classes.placeHolderIcon}`} />
                                </div>
                                : null}
                        </div>
                    </div>
                    {/* chat wrapper */}
                    {this.state.settingDisable ? <div style={{ height: chatHeight, width: participantWidth }} className={classes.actionsWrapper}>
                        <div className={classes.relativeContainer}>
                            <div style={{ height: 180, width: "100%" }} className={classes.chatWrapper}>
                                <div style={{ flexDirection: "column" }} className={classes.relativeContainer}>
                                    <div ref={chatWindow} style={{ flexDirection: "column", overflow: "auto" }} className={classes.relativeContainer}>
                                        <div className={classes.chatHistoryWrapper}>
                                            {this.state.chatHistory.map((data, index) => {
                                                return <div className={data.type === 1 ? classes.userChatBubble : classes.participantChatBubble} key={index + data.message}>
                                                    <span className={data.type === 1 ? classes.userChatBubbleText : classes.participantChatBubbleText}>{data.message}</span>
                                                </div>
                                            })}
                                            <div style={{ minHeight: 10 }} />
                                        </div>
                                    </div>
                                    <div className={classes.textInputWrapper}>
                                        <textarea ref={chatInput} maxLength={160} onKeyPress={this.onMessageKeyPress} placeholder="Type message here..." className={classes.inputText} type="text" value={this.state.messageText} onChange={this.handleMessage} />
                                        <SendIcon style={{ color: this.state.messageText.trim() ? "#00AD50" : "#4D4D4D" }} onClick={_ => this.state.messageText.trim() && this.sendMessage(this.state.messageText)} className={classes.sendIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    {/* setting wrapper */}
                    {this.state.chatDisable ? <div style={{ height: settingHeight, width: participantWidth }} className={classes.actionsWrapper}>
                        <div className={classes.relativeContainer}>
                            <div style={{ height: 180, width: "100%" }} className={classes.chatWrapper}>
                                <div style={{ flexDirection: "column", justifyContent: "flex-end", alignItems: "center" }} className={classes.relativeContainer}>
                                    <div className={classes.settingContentWrapper}>
                                        <div className={classes.settingText}>Select Camera</div>
                                        {this.getSelectInput(classes, "select-camera", this.state.videoInputDevices, this.state.selectedVideoInputDevices, this.handleVideoInputDeviceChange)}
                                    </div>
                                    <div className={classes.settingContentWrapper}>
                                        <div className={classes.settingText}>Select Microphone </div>
                                        {this.getSelectInput(classes, "select-Microphone", this.state.audioInputDevices, this.state.selectedAudioInputDevices, this.handleAudioInputChange)}
                                    </div>
                                    <div className={classes.settingContentWrapper}>
                                        <div className={classes.settingText}>Select Speaker </div>
                                        {this.getSelectInput(classes, "select-Speaker", this.state.audioOutputDevies, this.state.selectedAudioOutputDevies, this.handleAudioOutputChange)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    {/* remote video wrapper */}
                    <div style={{ height: mainHeight, width: participantWidth }} className={classes.paitentView}>
                        <div className={classes.relativeContainer}>
                            <div
                                ref={remoteMedia}
                                className={classes.remoteMedia}
                                id="remote-media"
                            />
                            {this.state.isParticipantOnline ? (this.state.participantVideoEnable && this.state.participantAudioEnable) ? null :
                                this.getParticipantTrack()
                                : <div className={classes.waitingMessage}>
                                    <div className={classes.waitingMessageWrapper}>
                                        <span className={classes.participantWaitngText}>Now waiting for...</span>
                                        <span className={classes.participantName}>{this.state.participantName}</span>
                                    </div>
                                </div>
                            }
                            <StepButton onClick={this.toggleSelfView} className={classes.expandIconStyle}>
                                <PersonIcon style={{ color: this.state.isSelfViewOpen ? "#00AD50" : "#4D4D4D" }} className={`${classes.expanIcon}`} />
                            </StepButton>
                            <StepButton onClick={this.toggleExpandWindow} className={classes.expandChatIconStyle}>
                                <img alt="" src={this.state.expandWindow ? windowReduceIcon : windowExpandIcon} className={`${classes.expanIcon}`} />
                            </StepButton>
                            <div className={classes.callButtonsWrapper}>
                                <StepButton onClick={this.endCall} className={classes.dropCallButtonStyle}>
                                    <CallEndIcon style={{ color: "#E82121" }} className={`${classes.dropCallIcon}`} />
                                </StepButton>
                                <div className={classes.callActionButtonsWrapper}>
                                    <StepButton onClick={this.toggleVideo} className={classes.videoButtonStyle}>
                                        {this.state.videoMute ? <VideocamOffIcon style={{ color: "#4D4D4D" }} className={`${classes.videoIcon}`} /> : <VideocamIcon style={{ color: "#00AD50" }} className={`${classes.videoIcon}`} />}
                                    </StepButton>
                                    <StepButton onClick={this.toggleMic} className={classes.microPhoneButtonStyle}>
                                        {this.state.micMute ? <MicOffIcon style={{ color: "#4D4D4D" }} className={`${classes.microphoneIcon}`} /> : <MicIcon style={{ color: "#00AD50" }} className={`${classes.microphoneIcon}`} />}
                                    </StepButton>
                                    <StepButton onClick={this.toggleChat} className={classes.chatButtonStyle}>
                                        {this.state.chatDisable ? <ChatBubbleIcon style={{ color: "#4D4D4D" }} className={`${classes.chatIcon}`} /> : <ChatBubbleIcon style={{ color: "#00AD50" }} className={`${classes.chatIcon}`} />}
                                    </StepButton>
                                </div>
                                <StepButton onClick={this.toggleSetting} className={classes.settingButtonStyle}>
                                    {this.state.settingDisable ? <SettingsIcon style={{ color: "#4D4D4D" }} className={`${classes.settingIcon}`} /> : <SettingsIcon style={{ color: "#00AD50" }} className={`${classes.settingIcon}`} />}
                                </StepButton>
                            </div>
                            {this.state.endCall ? <div className={classes.endCallWrapper}>
                                <div className={classes.endCallText}>Are you sure you want to end this call?</div>
                                <div className={classes.endCallActionWrapper}>
                                    <Button
                                        onClick={this.dropCall}
                                        variant="contained"
                                        color="primary"
                                        className={classes.buttonStyle}>
                                        Yes, end
                                    </Button>
                                    <Button
                                        onClick={_ => this.setState({ endCall: false })}
                                        variant="contained"
                                        color="primary"
                                        className={classes.cancelButtonStyle}>
                                        No, do not
                                    </Button>
                                </div>
                            </div> : null}
                        </div>
                    </div>
                    {this.state.userVideoOpened ? null : <div className={classes.connectingMessage}>Connecting...</div>}
                </div>
            </div>
        )
    }
}


export default withStyles(TwilioComponentStyle)(TwilioComponent);

